import React from 'react';
import {Anchor, Breadcrumbs, Paper, Group, Image} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import S from './Partners.module.scss';
import {partnersData} from "../../shared/mock/partners";

export const PartnersList = () => {
  const navigate = useNavigate();

  const items = [
    {title: 'Главная', url: '/'},
    {title: 'Бренды', active: true},
  ].map((item, index) => (
    <Anchor onClick={() => item.url && navigate(item.url)} key={index} data-active={item.active || undefined}>
      {item.title}
    </Anchor>
  ));

  return (
    <section id='brands-list'>
      <div className={S.brands}>
        <div className={S.brands_content}>
          <Breadcrumbs>
            {items}
          </Breadcrumbs>
          <h1>Бренды</h1>
          <div className={S.partnersList}>
            {partnersData.map((partner) => (
                <Paper
                    key={partner.id}
                    onClick={() => navigate(`/brands/${partner.id}`)}
                    className={S.partnerCard}
                >
                  <Group h="100%" className={S.group}>
                    <Image
                        src={partner.images}
                        alt={partner.title}
                        className={S.partnerLogo}
                        fit="contain"
                    />
                    <div className={S.titleList}>
                      {partner.title}
                    </div>
                  </Group>
                </Paper>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};